import { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import AuthShell from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";

export default function Register() {
  const { user, register, formatApiErrorDetail } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", confirm: "" });
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.password.length < 6) { setError("Password minimal 6 karakter."); return; }
    if (form.password !== form.confirm) { setError("Konfirmasi password tidak cocok."); return; }
    setLoading(true);
    try {
      await register({ name: form.name, email: form.email, password: form.password });
      toast.success("Akun berhasil dibuat!");
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Buat akun baru"
      subtitle="Mulai temukan bisnis yang paling cocok untuk Anda."
      footer={<>Sudah punya akun? <Link to="/login" className="font-semibold text-brand hover:underline" data-testid="link-login">Masuk</Link></>}
    >
      <form onSubmit={submit} className="space-y-5" data-testid="register-form">
        {error && <div className="rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700" data-testid="register-error">{error}</div>}
        <div>
          <Label htmlFor="name">Nama</Label>
          <Input id="name" required autoComplete="name" data-testid="register-name"
            className="mt-1.5 h-11" placeholder="Nama lengkap Anda"
            value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        </div>
        <div>
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" required autoComplete="email" data-testid="register-email"
            className="mt-1.5 h-11" placeholder="nama@email.com"
            value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
        </div>
        <div>
          <Label htmlFor="password">Password</Label>
          <div className="relative mt-1.5">
            <Input id="password" type={show ? "text" : "password"} required autoComplete="new-password" data-testid="register-password"
              className="h-11 pr-10" placeholder="Minimal 6 karakter"
              value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
            <button type="button" onClick={() => setShow((v) => !v)} className="absolute right-3 top-1/2 -translate-y-1/2 text-ink-muted" aria-label="Tampilkan password">
              {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
            </button>
          </div>
        </div>
        <div>
          <Label htmlFor="confirm">Konfirmasi Password</Label>
          <Input id="confirm" type={show ? "text" : "password"} required autoComplete="new-password" data-testid="register-confirm"
            className="mt-1.5 h-11" placeholder="Ulangi password"
            value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} />
        </div>
        <Button type="submit" disabled={loading} data-testid="register-submit" className="w-full h-11 bg-brand hover:bg-brand-hover">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Daftar Sekarang"}
        </Button>
      </form>
    </AuthShell>
  );
}
